/** @jsx React.DOM */
var React = require('react/addons')
var remotes = require('../../../helpers/remotes')
var constants = require('../../../helpers/constants')
var transactionsHelper = require('../../../helpers/transactions')
var AccountTransaction = require('./transaction')

var Transactions = React.createClass({displayName: 'Transactions',
  mixins: [React.addons.LinkedStateMixin],

  getInitialState: function() {
    return {
      txs: [],
      more: null,
      accountFilter: '',
      loading: false,
      marker: null
    }
  },

  fetch: function() {
    var remote = remotes.nodes
    var opts = {
      account: this.props.account,
      ledger_index_min: -1,
      ledger_index_max: -1,
      forward: false,
      marker: this.state.marker
    }

    this.setState({ loading: true })

    remote.requestAccountTransactions(opts, function(err, res) {
      this.setState({ loading: false })

      if (err) throw err

      var txs = res.transactions
      .filter(transactionsHelper.successOnly)

      this.setState({
        marker: res.marker,
        txs: this.state.txs.concat(txs),
        more: res.marker !== undefined
      })
    }.bind(this))
  },

  componentWillMount: function() {
    this.fetch()
  },

  onClickMore: function(e) {
    e.preventDefault()
    this.fetch()
  },

  render: function() {
    var txs

    if (this.state.txs) {
      var filtered = this.state.txs

      if (this.state.accountFilter) {
        filtered = filtered.filter(function(x) {
          if (!x.tx.Destination) return
          var send = this.props.account == x.tx.Account
          var other = send ? x.tx.Destination : x.tx.Account
          return ~other.indexOf(this.state.accountFilter)
        }.bind(this))
      }

      var rows = filtered.map(function(tx) {
        return AccountTransaction({key: tx.tx.hash, account: this.props.account, data: tx})
      }.bind(this))

      txs = React.DOM.table({className: "table table-bordered table-striped"}, 
        React.DOM.tbody(null, 
          rows
        )
      )
    }

    return React.DOM.div({className: "account-transactions"}, 
      React.DOM.h3(null, "Transactions", this.state.loading ? '...' :''), 
        React.DOM.div(null, 
          React.DOM.div({className: "form-group"}, 
            React.DOM.label({htmlFor: "accountFilter"}, "Account filter"), 
            React.DOM.input({name: "accountFilter", type: "text", valueLink: this.linkState('accountFilter'), className: "form-control"})
          )
        ), 
        txs, 
        this.state.more && React.DOM.div({className: "btn-group btn-group-justified", disabled: this.state.loading ? 'disabled' : ''}, 
        React.DOM.div({className: "btn-group"}, 
          React.DOM.button({disabled: this.state.loading ? 'disabled' : '', type: "button", className: "btn btn-default", onClick: this.onClickMore}, 
            "More", this.state.loading ? '...' :''
          )
        )
      )
    )
  }
})

module.exports = Transactions



//////////////////
// WEBPACK FOOTER
// ./src/routes/wrt/account/transactions.jsx
// module id = 480
// module chunks = 0